/**
 * @rundown/types — entity and DTO shapes shared by the API, the web app and
 * (later) the Expo app.
 *
 * Depends on `domain` and `policy`, never the reverse.
 *
 * The client/internal split is expressed in the types themselves: a
 * `ClientRequest` does not *contain* the internal fields, so it cannot leak them
 * by being serialised carelessly. There is no shared kitchen-sink DTO.
 */
/**
 * @rundown's mention id.
 *
 * A fixed, valid UUID rather than a word like "rundown": the message body
 * parser refuses a mention whose id is not a UUID, and the mention resolver
 * passes ids straight into a uuid column comparison. It is never a row in
 * `users` — the server strips it before resolving mentions and treats it as
 * "the bot was addressed".
 */
export const RUNDOWN_BOT_ID = '00000000-0000-4000-8000-00000000b070';
export const RUNDOWN_BOT_NAME = 'rundown';
//# sourceMappingURL=index.js.map